import { render, staticRenderFns } from "./IngredientListView.vue?vue&type=template&id=1726ef5a&scoped=true"
import script from "./IngredientListView.vue?vue&type=script&lang=js"
export * from "./IngredientListView.vue?vue&type=script&lang=js"
import style0 from "./IngredientListView.vue?vue&type=style&index=0&id=1726ef5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1726ef5a",
  null
  
)

export default component.exports